/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import ReactionModel from '@/models/reaction';
import { Icon } from '@/components';
interface EmoLoadingProps {
  reaction?: ReactionModel;
  emo?: any;
  handUp?: any;
}

const EmoLoading: React.FC<EmoLoadingProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    reaction: store.reaction,
  };
})(
  observer((props) => {
    const { formatMessage } = useIntl();

    return (
      <div className={s.wrapper}>
        <Icon name="icon-statusLoading_1" mode="symbol" spin size={32} className={s.icon}></Icon>
        <span className={s.text}>{formatMessage({ id: 'firstLoading' })}</span>
      </div>
    );
  })
);
export default EmoLoading;
